var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('HeroSection'),_c('AboutSection'),_c('BusinessSection'),_c('ProductServicesSection'),_c('ProductsSection'),_c('NewsSection'),_c('ContactSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }